import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, take } from 'rxjs';

import { ViveProgress } from '../classes/models/vive-progress';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ViveProgressService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  public getViveProgressCount(query: {} = {}): Observable<any> {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Admin: () =>
            this.http.get(`/api/v2/admin/viveProgress/count`, {
              params: query
            }),
          Client: () =>
            this.http.get(
              `/api/v2/company/${this.AuthService.getUserCompanyId()}/viveProgress/count`,
              { params: query }
            )
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  public saveViveProgress(ViveProgress: ViveProgress, query = {}) {
    // this will need to be changed for Client specific routing.
    return this.http.post<ViveProgress>(
      `/api/v2/admin/viveProgress/saveViveProgress`,
      ViveProgress,
      { params: query }
    );
  }

  public getViveProgress(query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Admin: () =>
            this.http.get(`/api/v2/admin/viveProgress/one`, { params: query })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }
}
